import { ActionTypes } from '../../../constants';

export const selectTemplate = (template: object) => {
  return {
    type: ActionTypes.SELECT_TEMPLATE,
    template,
  };
};
